import { CmsApiRecommendedJobsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedJobsBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsRecommendedJobsBlock } from './CmsRecommendedJobsBlock';

export const CmsRecommendedJobsBlockMapping: CmsBlockMapping<CmsApiRecommendedJobsBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsRecommendedJobsBlock,

    AmpComponent: CmsRecommendedJobsBlock,
  };
